module.exports = __webpack_public_path__ + "img/motorcycle-blue.b7d32a74.svg";